import { request } from '../request'

/**
 * 添加配额
 * @param data 添加配额的数据结构
 * @return {Promise}
 */
export function addQuota(data) {
  return request.post('/quota/surveyQuota', data)
}

/**
 * 根据 ID 获取配额详情
 * @param id
 * @return{Promise}
 */
export function getQuota(id) {
  return request({
    method: 'get',
    url: '/quota/surveyQuota/' + id
  })
}

/**
 * 修改配额
 * @param data 修改配额的数据结构
 * @return {Promise}
 */
export function updateQuota(data) {
  return request.put('/quota/surveyQuota', data)
}

/**
 * 查询样本筛选条件
 */
export function getSurveySampleCondition() {
  return request.get('/quota/surveySampleSend/sampleCondition')
}

/**
 * 查询样本筛选数量以及更多内容
 */
export function getSendNumber(data) {
  return request({
    url: '/quota/surveySampleSend/getSendNumber',
    method: 'post',
    data
  })
}

/**
 * 查询单条样本筛选数量以及更多内容
 */
export function getById(params) {
  return request({
    url: '/quota/surveySampleSend/getById',
    method: 'get',
    params
  })
}

/**
 * 撤销推送
 */
export function cancelSampleSend(params) {
  return request({
    url: '/quota/surveySampleSend/cancelSampleSend',
    method: 'get',
    params
  })
}

/**
 * 推送样本
 */

export function sendSampleForm(data) {
  return request({
    url: '/quota/surveySampleSend/sendCondition',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  })
}

/**
 * 查询推送样本的数据 传入问卷id
 */
export function getSampleData(id) {
  return request.get(`/quota/surveySampleSend/info/${id}`)
}
